// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(false);
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".apply-for-listing-modal__title[data-v-9b52e3a4]{font-size:1.375rem;line-height:1.875rem;font-weight:700}.apply-for-listing-modal[data-v-9b52e3a4] .Modal__container{max-width:22.25rem!important;min-width:unset!important;min-height:unset!important;width:100%;height:-webkit-fit-content;height:-moz-fit-content;height:fit-content}", ""]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___;
